import { createAction } from '@mews/framework';
import prefix from '../prefix';

export const UPDATE_SNACKBAR_SHOWN = prefix('UPDATE_SNACKBAR_SHOWN');
export const UPDATE_SNACKBAR_HIDDEN = prefix('UPDATE_SNACKBAR_HIDDEN');

export const showUpdateSnackbar = () => createAction(UPDATE_SNACKBAR_SHOWN);
export const hideUpdateSnackbar = () => createAction(UPDATE_SNACKBAR_HIDDEN);
